import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from "@angular/core";

import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {
  FullProblemTemplate
} from "../../../../admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component";

@Component({
    selector: 'audio-playback',
    styleUrls: ['../../../../admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.css'],
    imports: [FontAwesomeModule, FormsModule, MatCheckboxModule],
    templateUrl: './audio-playback.component.html'
})
export class AudioPlaybackComponent {
  @Input('answer') answer: string = ''
  @Input('audio_url') audio_url: string = '' 
  @Output() answerChange = new EventEmitter<string>()
  @ViewChild('audioElem') audioElem!: ElementRef<HTMLAudioElement>;

  ngOnChanges() {
    if (this.audioElem && this.audio_url) {
      const audio = this.audioElem.nativeElement;
      audio.src = this.audio_url;
      audio.load();      
    }
  }
}
